import { useLazyQuery } from '@apollo/client';

import { SearchQuestionDocument } from '../graphql/generated/graphql';

type ShownQuestionId = {
  id: string;
};

export const useSearch = (
  query: string,
  country: string,
  shownQuestions: ShownQuestionId[],
  languageId: string,
  questionnaireId: string,
) => {
  const [searchQuestion] = useLazyQuery(SearchQuestionDocument, {
    variables: {
      input: {
        keywords: query,
        country,
        languageId,
        questionnaireId,
        selectedQuestionIds: shownQuestions,
      },
    },
  });

  return searchQuestion;
};
